import { CruceFactura } from "./cruce-factura";

import { Proveedor } from "./proveedor";
import { Cliente } from "./cliente";
import { CruceDocumento } from "./cruce-documento";

export class Cruce{
    public constructor(
        public id: String = "",
        public tipo: String = "",
        public total_factura: number = 0,
        public total_cruce: number = 0,
        public cliente_proveedor_id: String = "",
        public forma_pago_id: String = "",
        //public caja_id: String = "",

        public usuario_id:String = null,
        public proveedor: Proveedor = new Proveedor(),
        public cliente: Cliente = new Cliente(),
        public crucefactura: Array<CruceFactura> = [],
        public crucedocumento: Array<CruceDocumento> = [],
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/cruce.ts